import { Component } from '@angular/core';
import module from 'app/modules/well-integrity-planning/well-integrity-planning.module';
import { WipService } from '../../services/wip.service';
import { WellIntergrityManagementService } from 'app/modules/well-integrity-management/service/well-intergrity-management.service';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-remarks',
  standalone: true,
  imports: module,
  templateUrl: './remarks.component.html',
  styleUrl: './remarks.component.scss'
})
export class RemarksComponent {
  form: FormGroup;
  tempForm: FormGroup;
  remarkObj: any = {};
  files: File[] = [];
  selectedFiles: File[] = [];


  // Custom toolbar allowing only text formatting
  modules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons           
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'indent': '-1' }, { 'indent': '+1' }],
      [{ 'align': [] }],
      ['clean']                                        // remove formatting
    ]
  };

  constructor(
    private service: WipService,
    private readonly dashboardService: WellIntergrityManagementService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.form = this.initForm();

    this.dashboardService.getWipRemark().subscribe((response) => {
      let remarkObj = response?.data.data[0] ?? {};

      this.form.get('id').setValue(remarkObj.id ?? null);
      this.form.get('remark').setValue(remarkObj.remark ?? '');

      if (remarkObj.id != null) {
        this.dashboardService.getWipRemarkbyId(remarkObj.id).subscribe((response) => {
          let attachments = response?.data?.attachments ?? []
          this.form.get('existingAttachments').setValue(attachments);
          this.tempForm = this.form.value;
        });
      }
    });
  }

  initForm() {
    // Initialize the form with validations
    return this.fb.group({
      id: null,
      remark: '',
      attachmentFiles: [[]],
      existingAttachments: [[]],
      removedAttachments: [[]],

    });
  }

  save() {
    const payload = this.form.getRawValue();
    const formData = new FormData();

    if (payload.id) {
      formData.append('id', payload.id);
    }
    if (payload.remark) {
      formData.append('remark', payload.remark);
    }

    if (payload.attachmentFiles && payload.attachmentFiles.length > 0) {
      payload.attachmentFiles.forEach((file: File) => {
        formData.append('attachmentFiles', file, file.name);
      });
    }

    if (payload.removedAttachments && payload.removedAttachments.length > 0) {
      payload.removedAttachments.forEach((attachment: any) => {
        this.remove(attachment)
      });
    }

    this.service.CreateUpdateRemarks(formData).subscribe((response) => {
    });
  }

  removeAttachmentTemp(event: any, index: number, attachementFrom: 'existingAttachments' | 'attachmentFiles') {
    event.stopPropagation();
    event.preventDefault();

    const attachments = this.form.get(attachementFrom);

    if (attachementFrom == 'attachmentFiles') {
      const value = attachments.value || [];
      value.splice(index, 1);
      attachments.setValue([...value]);
    } else {
      this.form.get('removedAttachments').setValue([...this.form.get('removedAttachments').value, attachments.value[index]])

      const value = attachments.value || [];
      value.splice(index, 1);
      attachments.setValue([...value]);
    }
  }

  remove(attachments: any) {
    this.dashboardService.deleteWipRemarkAttchmentById(attachments.id).subscribe();
  }

  view(event: any, index: number, attachementFrom: 'existingAttachments' | 'attachmentFiles') {
    event.stopPropagation();
    event.preventDefault();

    const file = this.form.get(attachementFrom).value[index];

    if (attachementFrom == 'attachmentFiles') {
      const blob = new Blob([file], { type: file.type });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } else {
      this.dashboardService.getWipRemarkAttchmentById(file.id).subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      });
    }
  }

  isFormChange(form: any, tempForm: any) {
    return JSON.stringify(form) === JSON.stringify(tempForm);
  }

  onFileChange(event: any) {
    const newFiles: File[] = this.form.get('attachmentFiles').value;
    this.selectedFiles = [...this.selectedFiles, ...newFiles];

    this.form.get('attachmentFiles')?.setValue(this.selectedFiles);
  }
}
